import { render, staticRenderFns } from "./Brainstorm.vue?vue&type=template&id=6bf4ff1d&"
import script from "./Brainstorm.vue?vue&type=script&lang=js&"
export * from "./Brainstorm.vue?vue&type=script&lang=js&"
import style0 from "./Brainstorm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports